import apiClient from "@/services/apiClient";

/** @typedef {import("@/APIVO/Student/IStudentUSISubmitRequest").IStudentUSISubmitRequest} IStudentUSISubmitRequest */
/** @typedef {import("@/APIVO/Student/IStudentUSIWorkflowActionRequest").IStudentUSIWorkflowActionRequest} IStudentUSIWorkflowActionRequest */

export const studentUSIService = {
  get: async (studentBookingId) => {
    const response = await apiClient.get("/StudentUSI", { params: { pStudentBookingId: studentBookingId } });
    return response.data;
  },
  /** @param {IStudentUSISubmitRequest} payload */
  submit: async (payload) => {
    const response = await apiClient.post("/StudentUSI/submit", payload);
    return response.data;
  },
  /** @param {IStudentUSIWorkflowActionRequest} payload */
  workflow: async (payload) => {
    const response = await apiClient.post("/StudentUSI/workflow", payload);
    return response.data;
  },
};
